module.exports = __webpack_public_path__ + "da66727221caa2d791c2fe1d06f55ce8.pdf";